// extracted by mini-css-extract-plugin
module.exports = {"defaultHeading":"_1e3cbe"};